import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Phone, Mail } from 'lucide-react';
import { Button } from './ui/button';
import { aboutData } from '../mock';

const AboutPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const scrollToContact = () => {
    navigate('/');
    setTimeout(() => {
      const element = document.querySelector('#contact');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section
        className="relative h-[60vh] bg-cover bg-center flex items-center"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.6)), url(${aboutData.heroImage})`
        }}
      >
        <div className="container mx-auto px-4 relative z-10">
          <Button
            variant="ghost"
            className="text-white hover:text-white hover:bg-white/20 mb-8"
            onClick={() => navigate('/')}
          >
            <ArrowLeft className="mr-2" size={20} />
            Ana səhifə
          </Button>
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-4">
            Haqqımızda
          </h1>
          <p className="text-xl text-white/90 max-w-2xl">
            Professional Steam Trap Management, HVAC və Mexaniki Həllər
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4 max-w-4xl">
          <div
            className="prose prose-lg max-w-none text-gray-700"
            dangerouslySetInnerHTML={{ __html: aboutData.detailedContent }}
            style={{
              lineHeight: '1.8'
            }}
          />


          {/* Company Values */}
          {/* <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-gradient-to-br from-blue-50 to-cyan-50 rounded-2xl p-6 text-center">
              <div className="text-4xl font-bold text-blue-600 mb-2">15+</div>
              <div className="text-gray-700 font-medium">İllik Təcrübə</div>
            </div>
            <div className="bg-gradient-to-br from-blue-50 to-cyan-50 rounded-2xl p-6 text-center">
              <div className="text-4xl font-bold text-blue-600 mb-2">500+</div>
              <div className="text-gray-700 font-medium">Uğurlu Layihə</div>
            </div>
            <div className="bg-gradient-to-br from-blue-50 to-cyan-50 rounded-2xl p-6 text-center">
              <div className="text-4xl font-bold text-blue-600 mb-2">100%</div>
              <div className="text-gray-700 font-medium">Müştəri Məmnuniyyəti</div>
            </div>
          </div> */}

          {/* CTA Section */}
          <div className="mt-16 bg-gradient-to-r from-blue-600 to-cyan-500 rounded-2xl p-8 md:p-12 text-white">
            <h3 className="text-3xl font-bold mb-4">
              Layihəniz haqqında danışaq
            </h3>
            <p className="text-lg mb-8 text-white/90">
              Professional komandamız sizə texniki məsləhət və həllər təqdim etməyə hazırdır.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <Button
                size="lg"
                className="bg-white text-blue-600 hover:bg-blue-50"
                onClick={scrollToContact}
              >
                <Mail className="mr-2" size={20} />
                Əlaqə formu
              </Button>
              <Button
                size="lg"
                variant="outline"
                className="border-white text-white hover:bg-white/20"
                onClick={() => window.location.href = 'tel:+994104650494'}
              >
                <Phone className="mr-2" size={20} />
                +994104650494
              </Button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutPage;
